import { Product } from '../../types';
export let Environment = /*#__PURE__*/function (Environment) {
  Environment["Staging"] = "stg";
  Environment["Production"] = "prod";
  return Environment;
}({});

/**
 * Resolves product environment type,
 * Falls back to Environment.Staging
 *
 * !!! Trello only, other products to be added
 *
 * @param origin
 */
export const getEnvName = (origin = ((_window, _window$location) => (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.origin)()) => ['https://trello.com'].includes(origin) ? Environment.Production : Environment.Staging;
const getProduct = product => {
  if (product) {
    const lowerJira = Product.JIRA.toLowerCase();
    const lowerProduct = product.toLowerCase();
    if (lowerProduct.includes(lowerJira)) {
      return lowerJira;
    }
    return lowerProduct;
  }
};
export const getLoginUrl = (productType, env = getEnvName(), continueUrl = String(window.location), loginHint) => {
  const baseUrl = env === Environment.Production ? 'https://id.atlassian.com/login' : 'https://id.stg.internal.atlassian.com/login';
  const product = getProduct(productType);
  return `${baseUrl}?continue=${encodeURIComponent(continueUrl)}${product ? `&application=${encodeURIComponent(product)}` : ''}
  ${loginHint ? `&login_hint=${encodeURIComponent(loginHint)}` : ''}`;
};